<div class="document-modal" [class.active]="active">
    <div class="document-modal-background">
        <div class="document-modal-container" [innerHTML]="preview">
        </div>
    </div>

    <button class="document-modal-close" (click)="close()">
        <i class="fa fa-times" aria-hidden="true"></i>
    </button>
</div>